/**
 * Extracts the Instagram handle from a full URL or raw input.
 * @param {string} value - The full Instagram URL or handle.
 * @returns {string} - Instagram handle without '@'
 */
export function extractInstagramHandle(value) {
  if (!value) return 'instagram';

  // If it's already in @handle format, strip the '@'
  if (value.startsWith('@')) return value.slice(1);

  try {
    const parsed = new URL(value);
    const segments = parsed.pathname.split('/').filter(Boolean);
    return segments[0] || 'instagram';
  } catch {
    // If it's not a valid URL, return raw value
    return value;
  }
}
